import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TextContent } from "../../../../../shared/TextContent/TextContent";
import { supportedSystemOperationsData } from "../SupportedSystemOperationsData";
import DynamicTable from "../../../../../shared/DynamicTable/DynamicTable";
import CustomBreadCrumbs from "../../../../../shared/BreadCrumbs/CustomBreadCrumbs";
import SideBarData from "../../../../Documentation/SideBar/SideBarData";

function SupportedSystemOperationsDetials() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlValue = queryParams.get("value");
  const [systemOperationData] = supportedSystemOperationsData.table_data.filter(
    (data) => data.name.toLowerCase() === urlValue
  );
  const [valueNotFound, setValueNotFound] = useState(false);

  const inParametersFlag = systemOperationData.subgroup["inParameters"]?.header;
  const outParametersFlag =
    systemOperationData.subgroup["outParameters"]?.header;

  useEffect(() => {
    if (
      !urlValue ||
      !systemOperationData[urlValue] ||
      !systemOperationData[urlValue].subgroup.heading
    ) {
      setValueNotFound(false);
    }
  }, []);

  if (valueNotFound) {
    return "Value not found";
  }

  return (
    <section className="page-group" id="system-operations-details">
      <CustomBreadCrumbs
        breadcrumbs={[
          `${SideBarData[2].subgroups[1]}`,
          `${systemOperationData.name}`,
        ]}
      />
      <div style={{ color: "red" }}>
        <TextContent
          header={
            systemOperationData.subgroup.heading[0].toUpperCase() +
            systemOperationData.subgroup.heading.slice(1) +
            ` ${systemOperationData.name}`
          }
          description={
            systemOperationData.subgroup.description ||
            "Description not found for this operation"
          }
        />
      </div>
      {inParametersFlag && (
        <div className="in-parameters table-container-custom">
          <DynamicTable
            title={systemOperationData.subgroup.inParameters.header}
            columns={systemOperationData.subgroup.inParameters.columns}
            data={systemOperationData.subgroup.inParameters.data}
          />
        </div>
      )}
      <br />
      {outParametersFlag && (
        <div className="out-parameters table-container-custom">
          <DynamicTable
            title={systemOperationData.subgroup.outParameters.header}
            columns={systemOperationData.subgroup.outParameters.columns}
            data={systemOperationData.subgroup.outParameters.data}
          />
        </div>
      )}
    </section>
  );
}

export default SupportedSystemOperationsDetials;
